import { INotifier, INotifierMessage } from '@app/core/interface/notifier';
import {HttpErrorResponse} from "@angular/common/http";

export abstract class BaseNotifier implements INotifier {

  /**
   * @param {string} value
   */
  public abstract success(value: string): void;

  /**
   * @param {INotifierMessage} value
   */
  public abstract error(value: INotifierMessage): void;

  /**
   * @param {INotifierMessage} value
   * @returns {string}
   */
  protected getMessage(value: INotifierMessage): string {
    if (typeof value === 'string') {
      return value;
    }

    if ((value instanceof HttpErrorResponse)) {
      return value.error?.message || 'Server is unavailable';
    }
    return value?.message || 'Server is unavailable';
  }
}
